import React from "react";
import { Stack, Typography } from "@mui/material";
import { HubCardStack } from "../../components";

const ResetPasswordSuccess = () => {
  return (
    <HubCardStack
      gap="5px"
      sx={{
        borderLeft: "25px solid",
        borderColor: "hubColors.greenMain",
      }}
    >
      <Typography variant="boldCaption">Reset Request Received</Typography>
      <Typography variant="caption">
        Check your email inbox for a message containing your password reset
        link. If you didn’t receive one, please check your email’s spam folder
        and allow a few minutes before trying again.
      </Typography>
    </HubCardStack>
  );
};

export default ResetPasswordSuccess;
